<template>
    <div class="soundWave-top" :style="{ height: height }">
        <div class="record-panel-wrap">
            <div class="mainBox">
                <div ref="ctrlProcessWave" style="height: 100%; width: 100%; box-sizing: border-box; display: inline-block; vertical-align: bottom" class="ctrlProcessWave"></div>
            </div>
        </div>
    </div>
</template>

<script>
// 加载必须要的core，demo简化起见采用的直接加载类库，实际使用时应当采用异步按需加载
import Recorder from "recorder-core";
// 需要使用到的音频格式编码引擎的js文件统统加载进来，这些引擎文件会比较大
import "recorder-core/src/engine/mp3";
import "recorder-core/src/engine/mp3-engine";
import "recorder-core/src/engine/wav";

// 可选的扩展
import "recorder-core/src/extensions/frequency.histogram.view.js";
import "recorder-core/src/extensions/lib.fft.js";
import Util from "@/util/util.js";

export default {
    props: {
        // 录音最大时长
        max: {
            default: 60, // 秒
        },
        // 等待多长时间算是没音乐
        wait: {
            default: 10000, // 毫秒
        },
        // 等待音频的层级， 多大的声音算是有效
        waitLevel: {
            default: 5,
        },
        // 等待音频的层级， 多大的声音算是有效
        showChat: {
            type: Boolean,
            default: true,
        },
        height: {
            type: [String, Number],
            default: "80px",
        },
    },
    data() {
        return {
            // 录音的格式
            type: "wav",
            bitRate: 16,
            sampleRate: 16000,

            rec: 0, // 实例
            duration: 0, // 时长
            powerLevel: 0,

            logs: [], // 日志
            isRecording: false, // 是不是正在录音种
            successCallback: "",
            waitTimer: null,
            prevChunk: null,
            isSending: false,
        };
    },

    methods: {
        /**
         *
         * @param {*} errorCallback
         */
        recStart: function (errorCallback) {
            let self = this;
            if (this.rec) {
                this.rec.start();
            } else {
                this.recInit(() => {}, errorCallback);
            }
        },
        recStop: function () {
            var self = this;
            var rec = self.rec;
            if (!rec) {
                self.reclog("未打开录音", 1);
                return;
            }

            rec.stop(
                function (blob, duration) {
                    let record = {
                        key: "record_" + Math.random().toString(36).slice(2, 12),
                        name: Util.formatDate(new Date(), "yyyyMMddhhmmss") + "." + self.type,
                        blob: blob,
                        duration: duration,
                        rec: rec,
                    };
                    self.isRecording = false;
                    self.$emit("stoped", record);
                },
                function (s) {
                    self.reclog("结束出错：" + s, 1);
                }
            ); // 不自动close
        },
        /** 初始化播放器
         *
         *cb     成功回调
         *cb2     失败回调
         * */
        recInit: function (cb, cb2) {
            var self = this;
            this.duration = 0;
            this.powerLevel = 0;
            this.isRecording = false;
            var prevChunk = null;
            var sampleBuf = new Int16Array();

            var rec = (this.rec = Recorder({
                type: "wav", //输出类型：mp3,wav等，使用一个类型前需要先引入对应的编码引擎
                bitRate: 16, //比特率，必须是数字 wav(位):16、8，MP3(单位kbps)：8kbps时文件大小1k/s，16kbps 2k/s，录音文件很小
                sampleRate: 16000,
                // type: self.type,
                // bitRate: self.bitRate,
                // sampleRate: self.sampleRate,
                onProcess: function (buffers, powerLevel, duration, sampleRate, newBufferIdx) {
                    //buffers=[[Int16,...],...]：缓冲的PCM数据块(16位小端LE)，为从开始录音到现在的所有pcm片段，每次回调可能增加0-n个不定量的pcm片段。
                    //注意：buffers数据的采样率为bufferSampleRate，它和set.sampleRate不一定相同，可能为浏览器提供的原始采样率rec.srcSampleRate，也可能为已转换好的采样率set.sampleRate；如需浏览器原始采样率的数据，请使用rec.buffers原始数据，而不是本回调的参数；如需明确和set.sampleRate完全相同采样率的数据，请在onProcess中自行连续调用采样率转换函数Recorder.SampleData()，配合mock方法可实现实时转码和压缩语音传输；修改或替换buffers内的数据将会改变最终生成的音频内容（注意不能改变第一维数组长度），比如简单有限的实现实时静音、降噪、混音等处理，详细参考下面的rec.buffers
                    //powerLevel：当前缓冲的音量级别0-100。
                    //bufferDuration：已缓冲时长。
                    //bufferSampleRate：buffers缓存数据的采样率（当type支持边录边转码(Worker)时，此采样率和设置的采样率相同，否则不一定相同）。
                    //newBufferIdx:本次回调新增的buffer起始索引。
                    //asyncEnd：fn() 如果onProcess是异步的(返回值为true时)，处理完成时需要调用此回调，如果不是异步的请忽略此参数，此方法回调时必须是真异步

                    self.isRecording = true;
                    self.duration = duration;
                    self.powerLevel = powerLevel;

                    if (self.showChat) {
                        // 显示频域 显示波形
                        self.wave && self.wave.input(buffers[buffers.length - 1], powerLevel, sampleRate);
                    }

                    const newBuffers = buffers.slice(newBufferIdx);

                    //将rec.buffers转成pcm 科大讯飞使用的数据
                    const chunk = Recorder.SampleData(newBuffers, sampleRate, self.sampleRate, null);
                    // Emit process event with converted data
                    self.$emit("process", chunk.data, powerLevel, duration, self.sampleRate, newBuffers);
                    //  本地模型使用的数据
                    var data_48k = buffers[buffers.length - 1];
                    var array_48k = new Array(data_48k);
                    var data_16k = Recorder.SampleData(array_48k, sampleRate, 16000).data;

                    sampleBuf = Int16Array.from([...sampleBuf, ...data_16k]);
                    var chunk_size = 960; // for asr chunk_size [5, 10, 5]
                    while (sampleBuf.length >= chunk_size) {
                        var sendBuf = sampleBuf.slice(0, chunk_size);
                        sampleBuf = sampleBuf.slice(chunk_size, sampleBuf.length);
                        // wsconnecter.wsSend(sendBuf);
                        self.$emit("localProcess", sendBuf);
                    }

                    // console.log("111111111powerLevel", powerLevel);
                    if (self.powerLevel >= self.waitLevel) {
                        self.waitTimer && clearTimeout(self.waitTimer);
                        self.waitTimer = setTimeout(() => {
                            console.log("222222222222powerLevel----长时间level低退出了");
                            self.$emit("speechEnd");
                            // self.recStop();
                        }, self.wait);
                    }

                    if (self.max && duration / 1000 > self.max) {
                        self.recStop();
                    }
                },
            }));

            //打开麦克风授权获得相关资源
            rec.open(
                function () {
                    //rec.start() 此处可以立即开始录音，但不建议这样编写，因为open是一个延迟漫长的操作，通过两次用户操作来分别调用open和start是推荐的最佳流程

                    if (self.showChat) {
                        //创建可视化，指定一个要显示的div
                        self.wave = Recorder.FrequencyHistogramView({
                            elem: self.$refs.ctrlProcessWave,
                            lineCount: 8,
                            position: 0,
                            minHeight: 1,
                            fallDuration: 400,
                            stripeEnable: false,
                            mirrorEnable: true,
                        });
                    }
                    rec.start();
                    self.$emit("started");
                    cb && cb();
                },
                function (msg, isUserNotAllow) {
                    //用户拒绝未授权或不支持
                    self.reclog((isUserNotAllow ? "UserNotAllow，" : "") + "打开失败：" + msg, 1);
                    self.$emit("error");
                    cb2 && cb2();
                }
            );
        },
        recDestory: function () {
            var self = this;
            self.rec && self.rec.close();
            self.rec = null;
        },

        reclog: function (msg, color, res) {
            this.logs.splice(0, 0, {
                idx: this.logs.length,
                msg: msg,
                color: color,
                res: res,

                playMsg: "",
                down: 0,
                down64Val: "",
            });
        },

        /**
         * 试听，播放
         *
         */
        recplay: function (item, index) {
            var self = this;

            var audio = this.$refs.LogAudioPlayer;
            audio.controls = true;
            if (!(audio.ended || audio.paused)) {
                audio.pause();
            }
            audio.onerror = function (e) {
                // logmsg('<span style="color:red">播放失败[' + audio.error.code + ']' + audio.error.message + '</span>')
            };
            audio.src = window.URL.createObjectURL(item.blob);
            audio.play();
        },

        recdown64: function (item, index) {
            var self = this;

            var reader = new FileReader();
            reader.onloadend = function () {
                item.down64Val = reader.result;
            };
            reader.readAsDataURL(item.blob);
        },
        getTime: function () {
            var now = new Date();
            var t = ("0" + now.getHours()).substr(-2) + ":" + ("0" + now.getMinutes()).substr(-2) + ":" + ("0" + now.getSeconds()).substr(-2);
            return t;
        },
        /**
         * @param  {s} 秒数
         * @return {String} 字符串
         *
         * @example formatHMS(3610) // -> 1h0m10s
         */
        formatHMS(s) {
            var str = "";
            if (s > 3600) {
                str = Math.floor(s / 3600) + "h " + Math.floor((s % 3600) / 60) + "m " + (s % 60).toFixed(1) + "s ";
            } else if (s > 60) {
                str = Math.floor(s / 60) + "m " + (s % 60).toFixed(1) + "s ";
            } else {
                str = (s % 60).toFixed(1) + "s ";
            }
            return str;
        },
        intp: function (s, len) {
            s = s === null ? "-" : s + "";
            if (s.length >= len) {
                return s;
            } else {
                return ("_______" + s).substr(-len);
            }
        },
    },
    beforeDestroy() {
        this.recDestory();
    },
};
</script>
<style lang="less" scoped>
/* body {
	word-wrap: break-word;
	background: #f5f5f5 center top no-repeat;
	background-size: auto 680px;
} */

.soundWave-top {
    .record-img-wrap {
        // cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100px;

        .record-img {
            width: 32px;
        }

        .box {
            width: 20px;
            box-sizing: border-box;

            .wifi-symbol {
                width: 50px;
                height: 50px;
                box-sizing: border-box;
                overflow: hidden;
                position: relative;
                transform: rotate(135deg);
            }

            .wifi-circle {
                border: 5px solid rgb(51, 153, 255);
                border-radius: 50%;
                position: absolute;
            }

            .first {
                width: 5px;
                height: 5px;
                background: #cccccc;
                top: 45px;
                left: 45px;
            }

            .second {
                width: 25px;
                height: 25px;
                top: 35px;
                left: 35px;
                animation: fadeInOut 1s infinite 0.2s;
            }

            .third {
                width: 40px;
                height: 40px;
                top: 25px;
                left: 25px;
                animation: fadeInOut 1s infinite 0.4s;
            }

            @keyframes fadeInOut {
                0% {
                    opacity: 0;
                    /*初始状态 透明度为0*/
                }

                100% {
                    opacity: 1;
                    /*结尾状态 透明度为1*/
                }
            }
        }
    }

    .record-panel-wrap {
        max-width: 700px;
        margin: 0 auto;

        .mainBox {
            margin-top: 12px;
            // padding: 12px;
            border-radius: 6px;
            background: #fff;
        }

        .mainBtn {
            display: inline-block;
            cursor: pointer;
            border: none;
            border-radius: 3px;
            background: #0b1;
            color: #fff;
            padding: 0 15px;
            margin-right: 10px;
            line-height: 36px;
            height: 36px;
            overflow: hidden;
            vertical-align: middle;
        }

        .mainBtn:active {
            background: #0a1;
        }

        .ctrlBtn {
            margin-top: 10px;
        }

        .pd {
            padding: 0 0 6px 0;
        }

        .lb {
            display: inline-block;
            vertical-align: middle;
            background: #00940e;
            color: #fff;
            font-size: 14rpx;
            padding: 2px 8px;
            border-radius: 99px;
        }
    }
}
</style>
